module.exports = __webpack_public_path__ + "static/media/notifications-not-found.55035c2a.svg";